import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Select } from "antd";
import { motion } from "framer-motion";

const { Option } = Select;

const InvoiceSettings = () => {
  return (
    <motion.div
      className="card container py-3"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >

      {/* CARD */}
      <motion.div
        initial={{ opacity: 0, scale: 0.97 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.15 }}
      >

        {/* TITLE */}
        <motion.h5
          className="fw-semibold mb-3 text-primary"
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.1 }}
        >
          Invoice Settings
        </motion.h5>

        {/* LOGO */}
        <motion.div
          className="row mb-4 align-items-center"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
        >
          <div className="col-md-4 fw-medium">Invoice Logo</div>

          <div className="col-md-8 mb-3">
            <div className="d-flex align-items-center p-3 bg-light rounded">
              <div
                className="bg-white border rounded me-3"
                style={{ width: "60px", height: "60px" }}
              ></div>

              <div>
                <div className="fw-semibold mb-3">Logo</div>
                <small className="text-muted d-block mb-2">
                  Recommended size 40px × 40px
                </small>

                <motion.button
                  whileTap={{ scale: 0.9 }}
                  className="btn btn-outline-primary btn-sm me-2 "
                >
                  Upload
                </motion.button>

                <motion.button
                  whileTap={{ scale: 0.9 }}
                  className="btn btn-outline-secondary btn-sm"
                >
                  Cancel
                </motion.button>
              </div>
            </div>
          </div>
        </motion.div>

        {/* PREFIX */}
        <motion.div
          className="row mb-3 align-items-center"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.15 }}
        >
          <div className="col-md-4 fw-medium">Invoice Prefix</div>
          <div className="col-md-8 mb-3">
            <input className="form-control" />
          </div>
        </motion.div>

        {/* DUE */}
        <motion.div
          className="row mb-3 align-items-center"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
        >
          <div className="col-md-4 fw-medium">Invoice Due</div>
          <div className="col-md-8 mb-3">
            <Select placeholder="Select" style={{ width: "100%" }}>
              <Option value="7">7 Days</Option>
              <Option value="15">15 Days</Option>
              <Option value="30">30 Days</Option>
            </Select>
          </div>
        </motion.div>

        {/* ROUND OFF */}
        <motion.div
          className="row mb-3 align-items-center"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.25 }}
        >
          <div className="col-md-4 fw-medium">Invoice Round Off</div>
          <div className="col-md-8 mb-3">
            <Select placeholder="Select" style={{ width: "100%" }}>
              <Option value="none">None</Option>
              <Option value="round">Round</Option>
              <Option value="ceil">Ceil</Option>
              <Option value="floor">Floor</Option>
            </Select>
          </div>
        </motion.div>

        {/* TOGGLE */}
        <motion.div
          className="row mb-3 align-items-center"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
        >
          <div className="col-md-4 fw-medium">Show Company Details</div>
          <div className="col-md-8 mb-3">
            <div className="form-check form-switch">
              <input className="form-check-input" type="checkbox" />
            </div>
          </div>
        </motion.div>

        {/* TERMS */}
        <motion.div
          className="row mb-4 align-items-start"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.35 }}
        >
          <div className="col-md-4 fw-medium">Invoice Terms</div>
          <div className="col-md-8">
            <textarea className="form-control" rows="4"></textarea>
          </div>
        </motion.div>

        <hr />

        {/* BUTTONS */}
        <motion.div
          className="d-flex justify-content-end"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
        >
          <motion.button
            whileTap={{ scale: 0.9 }}
            className="btn btn-outline-danger btn-sm me-2"
          >
            Cancel
          </motion.button>

          <motion.button
            whileTap={{ scale: 0.9 }}
            className="btn btn-outline-success btn-sm"
          >
            Save
          </motion.button>
        </motion.div>
      </motion.div>
    </motion.div>
  );
};

export default InvoiceSettings;